export default function AllBrands() {
  const brands = [
    "GU",
    "Roto",
    "Siegenia",
    "Winkhaus",
    "Ferco",
    "Maco",
    "Aubi",
    "Cadiou",
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-4 md:mb-6">
            Toutes marques de quincaillerie
          </h2>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6 md:mb-8">
            Les fenêtres aluminium, souvent plus grandes et plus lourdes que les fenêtres PVC, utilisent des ferrures de qualité supérieure capables de supporter des charges importantes. Les fabricants de menuiserie aluminium (Sapa, Technal, Komerling, Reynaers, etc.) s'appuient sur des systèmes de quincaillerie spécifiques : GU, Roto, Siegenia, Winkhaus, Ferco, Maco, Aubi ou Cadiou. Ces mécanismes sont robustes, mais leurs pièces mobiles (axes, ressorts, galets, ciseaux) s'usent avec le temps et la friction répétée. Nos techniciens sont formés à identifier la marque exacte en quelques minutes, même si elle n'est pas visible sur la poignée.
          </p>
          <p className="text-base md:text-lg text-plum-dark leading-relaxed mb-6 md:mb-8">
            Nous stockons des pièces pour les grandes marques de quincaillerie aluminium. Si nous n'avons pas la pièce exacte en stock, nous la commandons et revenons en 48h maximum. Vous ne payez pas le déplacement deux fois. Le remplacement de pièce est garanti 10 ans. Nous intervenons dans tout le Bas-Rhin, de Strasbourg à Haguenau, en passant par Schiltigheim, Illkirch-Graffenstaden et les communes environnantes.
          </p>
          <div className="flex flex-wrap gap-3">
            {brands.map((brand) => (
              <span
                key={brand}
                className="inline-flex items-center gap-2 bg-rose-50 border border-rose-100 rounded-xl px-4 py-2 text-sm md:text-base font-medium text-plum-dark"
              >
                <i className="ri-shield-check-line text-coral" />
                {brand}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}